// ============================================================================
// CANCUN100 — temaEquipo.js  (APP 2/14 · F10: UN tema por equipo · APP 2/20 Fase A: ÚNICO origen de color de la app)
// ----------------------------------------------------------------------------
// Referencia: 30 App sistema/Prototipos/paletas-por-equipo-2.0.html (manda). Lo único personal es claro u oscuro.
//   Sala       rosa → morado tenue   #F0447A → #9B6BDB
//   Top Tours  cielo → azul marino   #38BDF8 → #1E4FA0
//   Admin      morado               #9B6BFF → #5B2BB5
// Fondo de la página: un solo color tenue del equipo. El degradado vive solo en la cabecera y en el botón principal.
// Tarjetas de vidrio (.au-glass): blanco 80 % en claro / 4.5 % en oscuro, blur 18 px, borde definido, sombra suave y
// brillo aurora (dos radial-gradient del equipo, 7–14 %) en las esquinas.
// Botón principal: degradado del equipo con el extremo claro oscurecido lo justo para que el blanco dé ≥ 4.5
// (medido: Sala #d33c6b/#8c60c5 · TT #257da4/#1E4FA0 · Admin #855cdb/#5B2BB5).
// Los tokens --sk-* y --au-gold-* se conservan por compatibilidad (Stepper, ServicioCustom, MenuLateral, toggles):
// APP 2/20 Fase A: las variables del equipo se llaman --eq-* (antes --sk-*, resto de los skins). agentes.preferencias.skin se queda en la base y se ignora (R-004).
// ============================================================================

const rgba = (hex, a) => { const n = parseInt(String(hex).replace('#', ''), 16); return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`; };

export const EQUIPOS = {
  sala: {
    etiqueta: 'Sala de ventas', c1: '#F0447A', c2: '#9B6BDB', boton: ['#d33c6b', '#8c60c5'],
    claro:  { acento: '#D63A72', texto: '#A8255A', bg: '#FBF3F7', ink: '#1D1626', muted: '#665B72', a1: 'rgba(240,68,122,.10)', a2: 'rgba(155,107,219,.08)' },
    oscuro: { acento: '#FF7AA8', texto: '#FFA3C4', bg: '#130D16', ink: '#F6F0FA', muted: '#B3A6BF', a1: 'rgba(240,68,122,.14)', a2: 'rgba(155,107,219,.12)' },
  },
  tt: {
    etiqueta: 'Top Tours', c1: '#38BDF8', c2: '#1E4FA0', boton: ['#257da4', '#1E4FA0'],
    claro:  { acento: '#0B79B8', texto: '#0A5A8C', bg: '#F1F7FC', ink: '#0E2236', muted: '#4F657A', a1: 'rgba(56,189,248,.12)', a2: 'rgba(30,79,160,.07)' },
    oscuro: { acento: '#5CC8FA', texto: '#8FDBFF', bg: '#07111C', ink: '#EAF4FC', muted: '#9AB2C8', a1: 'rgba(56,189,248,.13)', a2: 'rgba(30,79,160,.16)' },
  },
  admin: {
    etiqueta: 'Administración', c1: '#9B6BFF', c2: '#5B2BB5', boton: ['#855cdb', '#5B2BB5'],
    claro:  { acento: '#7339E0', texto: '#5A25B8', bg: '#F5F2FC', ink: '#1C1630', muted: '#625B7A', a1: 'rgba(155,107,255,.12)', a2: 'rgba(91,43,181,.07)' },
    oscuro: { acento: '#B49BFF', texto: '#CDBDFF', bg: '#0E0B18', ink: '#F2EEFC', muted: '#ADA4C6', a1: 'rgba(155,107,255,.14)', a2: 'rgba(91,43,181,.16)' },
  },
};
export const EQUIPO_DEFAULT = 'sala';
export const LLAVE_EQUIPO = 'c100-equipo'; // último equipo en este navegador (el login lo usa antes de entrar)
export const equipoValido = (k) => (EQUIPOS[k] ? k : EQUIPO_DEFAULT);
export const leerEquipoGuardado = () => { try { return equipoValido(localStorage.getItem(LLAVE_EQUIPO) || ''); } catch { return EQUIPO_DEFAULT; } };
export const guardarEquipo = (k) => { try { localStorage.setItem(LLAVE_EQUIPO, equipoValido(k)); } catch { /* sin storage */ } };

// Paleta en JS (para los estilos inline de App.js: C.rosa, C.naranja, C.grad, C.gradBtn…).
export const paletaEquipo = (equipo, modo = 'light') => {
  const e = EQUIPOS[equipoValido(equipo)];
  const m = modo === 'dark' ? e.oscuro : e.claro;
  const oscuro = modo === 'dark';
  return {
    equipo: equipoValido(equipo), etiqueta: e.etiqueta,
    c1: e.c1, c2: e.c2, acento: m.acento, acentoTexto: m.texto, bg: m.bg, ink: m.ink, muted: m.muted,
    degradado: `linear-gradient(100deg, ${e.c1}, ${e.c2})`,
    degradadoV: `linear-gradient(${e.c1}, ${e.c2})`,
    gradBoton: `linear-gradient(100deg, ${e.boton[0]}, ${e.boton[1]})`,
    sombraBoton: '0 1px 2px rgba(0,0,0,.18)', // APP 2/14 F14 (3-nov 01:20): solo sombra neutra de 1–2 px, sin sombra de color, igual en todos los botones principales
    tinte: rgba(m.acento, 0.10), tinteFuerte: rgba(m.acento, oscuro ? 0.16 : 0.12), borde: rgba(m.acento, oscuro ? 0.45 : 0.35),
    a1: m.a1, a2: m.a2,
    vidrio: oscuro ? 'rgba(255,255,255,.045)' : 'rgba(255,255,255,.80)',
    vidrioBorde: oscuro ? 'rgba(255,255,255,.12)' : 'rgba(30,20,40,.12)',
    capa1: oscuro ? '#15111E' : '#FFFFFF', capa2: oscuro ? '#1B1626' : '#FFFFFF',
    campo: oscuro ? 'rgba(0,0,0,.25)' : 'rgba(255,255,255,.75)',
    linea: oscuro ? 'rgba(255,255,255,.09)' : 'rgba(30,20,40,.10)',
    ok: oscuro ? '#3DD39A' : '#0F8F62', warn: oscuro ? '#F2C14E' : '#A86B12',
    error: oscuro ? '#FF6B8F' : '#C81E4A', // APP 2/20 Fase A: rojo único (antes #ff2d2d / #ff5c8a sueltos en 8 archivos)
    // APP 2/20: tokens del mockup aprobado (mis-ventas-y-mi-bolsa-2.0), tal cual, con el c1/c2 del equipo
    faint: oscuro ? '#7D7189' : '#A39AAD',
    glass: oscuro ? 'rgba(255,255,255,.055)' : 'rgba(255,255,255,.72)', glass2: oscuro ? 'rgba(255,255,255,.035)' : 'rgba(255,255,255,.55)',
    edge: oscuro ? 'rgba(255,255,255,.14)' : 'rgba(255,255,255,.9)', hair: oscuro ? 'rgba(255,255,255,.08)' : 'rgba(40,20,50,.08)',
    glow1: rgba(e.c1, oscuro ? 0.20 : 0.16), glow2: rgba(e.c2, oscuro ? 0.20 : 0.14),
    off: oscuro ? 'rgba(255,255,255,.10)' : 'rgba(40,20,50,.10)', accSoft: rgba(m.acento, oscuro ? 0.10 : 0.08),
    sombra: oscuro ? '0 1px 1px rgba(0,0,0,.3), 0 10px 30px -10px rgba(0,0,0,.6)' : '0 1px 1px rgba(40,20,50,.04), 0 6px 16px -6px rgba(40,20,50,.10), 0 24px 48px -24px rgba(90,40,110,.22)',
  };
};
// Color del equipo en JS (insignias que mezclan alfa en hex). Sustituye a tema.EQUIPO / TURQUESA_TT y al '#0f9dae' suelto.
export const COLOR_EQUIPO = { sala: EQUIPOS.sala.c1, tt: EQUIPOS.tt.c1, admin: EQUIPOS.admin.c1 };

const bloque = (t) => `
  --equipo: ${t.c1};
  --equipo-grad: ${t.degradado};
  --au-raya: ${t.degradadoV};
  --au-bg-base: ${t.bg};
  --au-bg-layer-1: ${t.capa1};
  --au-bg-layer-2: ${t.capa2};
  --au-text-primary: ${t.ink};
  --au-text-secondary: ${t.muted};
  --au-text-faint: ${t.faint};
  --au-glass-fill: ${t.vidrio};
  --au-glass-fill-strong: ${t.vidrio};
  --au-glass-border: ${t.vidrioBorde};
  --au-glass-border-strong: ${t.vidrioBorde};
  --au-glass-blur: 24px;
  --au-shadow-card: ${t.sombra};
  --au-aurora-1: ${t.a1};
  --au-aurora-2: ${t.a2};
  --au-gold-from: ${t.c1};
  --au-gold-to: ${t.c2};
  --au-gold-grad: ${t.degradado};
  --au-gold-solid: ${t.acentoTexto};
  --au-gold-bg: ${t.tinte};
  --au-gold-border: ${t.borde};
  --au-tint-gold: ${t.tinte};
  --au-text-on-accent: #fff;
  --au-success-fg: ${t.ok};
  --au-yellow-fg: ${t.warn};
  --au-error-fg: ${t.error};
  --eq-acento: ${t.acento};
  --eq-acento-texto: ${t.acentoTexto};
  --eq-grad: ${t.degradado};
  --eq-grad-boton: ${t.gradBoton};
  --eq-c1: ${t.c1};
  --eq-c2: ${t.c2};
  --eq-tinte: ${t.tinte};
  --eq-borde: ${t.borde};
  --eq-glass: ${t.glass};
  --eq-glass-2: ${t.glass2};
  --eq-edge: ${t.edge};
  --eq-hair: ${t.hair};
  --eq-glow1: ${t.glow1};
  --eq-glow2: ${t.glow2};
  --eq-off: ${t.off};
  --eq-faint: ${t.faint};
  --eq-ok: ${t.ok};
  --eq-warn: ${t.warn};
  --eq-error: ${t.error};
  --eq-acc-soft: ${t.accSoft};
  --eq-sombra: ${t.sombra};`;

// CSS de los tres equipos × dos modos. Se inyecta una vez; lo eligen data-equipo + data-theme del MISMO elemento (raíz de la app o del login),
// nunca el <html>: el login puede ir en claro mientras App.js deja el html en oscuro.
export const cssTemaEquipo = () => Object.keys(EQUIPOS).map((k) => `
[data-equipo="${k}"][data-theme="light"] {${bloque(paletaEquipo(k, 'light'))}
}
[data-equipo="${k}"][data-theme="dark"], [data-equipo="${k}"]:not([data-theme]) {${bloque(paletaEquipo(k, 'dark'))}
}`).join('\n');
